import React from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import useTabQueryParam from '../hooks/useTabQueryParam';

const TABS = [
  { key: 'members', label: 'Members', route: '' },
  { key: 'leave-policy', label: 'Leave Policy', route: 'leave-policy' },
  { key: 'holidays', label: 'Holidays', route: 'holidays' },
];

const CompanyLayout = () => {
  const roleId = localStorage.getItem('role_id');
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useTabQueryParam('tab', 'members');

  // Sync tab with route on mount and when route changes
  React.useEffect(() => {
    // If route matches, update tab
    if (location.pathname.endsWith('/company') || location.pathname.endsWith('/company/')) {
      setActiveTab('members');
    } else if (location.pathname.includes('/company/leave-policy')) {
      setActiveTab('leave-policy');
    } else if (location.pathname.includes('/company/holidays')) {
      setActiveTab('holidays');
    }
  }, [location.pathname, setActiveTab]);

  const handleTabClick = (tabKey, route) => {
    setActiveTab(tabKey);
    navigate(`/company/${route}`);
  };

  return (
    <div className="mt-8">
      <div className="flex gap-2 mb-6">
        {/* Only show Team tab for Manager (role id: 2) */}
        {roleId === '2' && (
          <button
            className={`px-6 py-2 rounded-t-md font-medium ${location.pathname.includes('/company/team') ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
            onClick={() => navigate('/company/team')}
          >
            Team
          </button>
        )}
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`px-6 py-2 rounded-t-md font-medium ${activeTab === tab.key ? 'bg-indigo-600 text-white' : 'bg-slate-100 text-slate-800 hover:bg-indigo-100'}`}
            onClick={() => handleTabClick(tab.key, tab.route)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="bg-white rounded-b-lg shadow p-8">
        <Outlet />
      </div>
    </div>
  );
};

export default CompanyLayout;
